import React from "react";
import { Link } from "react-router-dom";

const loginpage = () => {
  return (
    <div>
      <section class='section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4'>
        <div class='container'>
          <div class='row justify-content-center'>
            <div class='col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center'>
              <div class='card mb-3'>
                <div class='card-body'>
                  <div class='d-flex justify-content-center py-4'>
                    <a
                      href='index.html'
                      class='logo d-flex align-items-center w-auto'
                    >
                      <img src='https://app.realdo.in/favicon.png' class='h-9' alt='' />       
                    </a>
                  </div>
                  <div class='pt-4 pb-2'>
                    <h5 class='card-title text-center pb-0 fs-4'>
                      Login to Your Account
                    </h5>
                    <p class='text-center small'>
                      Enter your username & password to login
                    </p>
                  </div>

                  <form class='row g-3 needs-validation' novalidate>
                    <div class='col-12'>
                      <label for='yourUsername' class='form-label'>
                        Username
                      </label>
                      <div class='input-group has-validation'>
                        <span class='input-group-text' id='inputGroupPrepend'>
                          @
                        </span>
                        <input
                          type='text'
                          name='username'
                          class='form-control'
                          id='yourUsername'
                          required
                        />
                        <div class='invalid-feedback'>
                          Please enter your username.
                        </div>
                      </div>
                    </div>

                    <div class='col-12'>
                      <label for='yourPassword' class='form-label'>
                        Password
                      </label>
                      <input
                        type='password'
                        name='password'
                        class='form-control'
                        id='yourPassword'
                        required
                      />
                      <div class='invalid-feedback'>
                        Please enter your password!
                      </div>
                    </div>

                    <div class='col-12'>
                      <div class='form-check'>
                        <input
                          class='form-check-input'
                          type='checkbox'
                          name='remember'
                          value='true'
                          id='rememberMe'
                        />
                        <label class='form-check-label' for='rememberMe'>
                          Remember me
                        </label>
                      </div>
                    </div>
                    <div class='col-12'>
                      <Link to='/' class='text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800' type='submit'>
                        
                        Login
                      </Link>
                    </div>
                
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default loginpage;
